
	export default {
		name: "empty"
	}
